import HaspObject from './HaspObject';
import { processIconText } from '../utils/iconFonts';

export default class HaspMtrxButton extends HaspObject {
  constructor(config) {
    super(config);

    this.rect.fill(config.bg_color);
    this.rect.stroke(config.border_color);
    this.rect.setStrokeWidth(config.border_width);
    this.rect.cornerRadius(config.radius);

    this.haspid = undefined;
    this.text_font_family = config.text_font_family || 'Roboto Condensed';

    this.textObj = new Konva.Text({
      x: 0,
      y: 0,
      width: 'auto',
      height: 'auto',
      verticalAlign: 'middle',
      text: processIconText(config.text),
      align: 'center',
      fontSize: config.text_font,
      fontFamily: config.text_font_family,
      fill: config.text_color,
      listening: false,
      draggable: false,
      strokeWidth: 0,
      ellipsis: false,
      wrap: 'none',
      obj: 'text',
    });
    this.add(this.textObj);
    this.draggable(true);

    this.on('selected', (e) => {
    });

    this.on('text_text', (e) => {
      this.textObj.text(processIconText(this.text));
      //callback to matrix
      this.button_matrix.handleButtonTextChange(this);
    });

    this.updateButton();
  }

  setSelected(selected) {
    if (selected)
      this.rect.stroke('red')
    else
      this.rect.stroke(this.button_matrix.styleProp('item_buttons', 'border_color'))
  }

  updateButton() {
    this.rect.width(this.width());
    this.rect.height(this.height());
    this.textObj.width(this.rect.width());
    this.textObj.height(this.rect.height());
  }

}
